export default class ProxyDateUpdater extends HTMLDivElement {

    connectedCallback() {
        // Add event listener to the checkbox when the element is added to the DOM
        this.proxyCheckbox.addEventListener("change", this.handleChange);

        // After server validation 'isProxyChecked' can be true from the start.
        this.updateDateOptions();
    }

    handleChange = () => {
        // Update the dropdown options whenever the Proxy checkbox is changed
        this.updateDateOptions();
    }

    updateDateOptions() {
        // Find the existing <select> element
        const selectElement = this.selectList;

        // Clear the current <option> elements
        selectElement.innerHTML = '';

        // Generate the new <option> elements based on the Proxy value
        const dates = this.generateEntryDates(this.proxyCheckbox.checked);

        dates.forEach(date => {
            const option = document.createElement('option');
            option.value = date;
            option.textContent = date;
            selectElement.appendChild(option);
        });
    }

    generateEntryDates(isProxyChecked) {
        const dates = [];
        const currentDate = new Date();

        if (isProxyChecked) {
            // If Proxy is true, show next three months
            for (let i = 1; i < 4; i++) {
                const futureDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
                const formattedDate = this.formatDate(futureDate);
                dates.push(formattedDate);
            }

        } else {
            // If Proxy is false, show three dates (current month and the next two months)
            for (let i = 0; i < 3; i++) {
                const futureDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
                const formattedDate = this.formatDate(futureDate);
                dates.push(formattedDate);
            }
        }

        return dates;
    }

    formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add leading zero to months
        return `${year}-${month}-01`; // Format as "YYYY-MM-01"
    }

    // Getter to retrieve the Proxy checkbox element
    get proxyCheckbox() {
        return this.querySelector("#FormData_Proxy");
    }

    get selectList() {
        return this.querySelector("#FormData_EntryDate");
    }

}

// Define the custom element, extending from "div"
customElements.define("proxy-date-updater", ProxyDateUpdater, { extends: "div" });
